import React from 'react'
import Footer from './Footer'

const VisitAgain = () => {
  document.title ="Visit Again | ClickStar";
  return (
    <div className='max-h-[100vh] overflow-hidden mx-auto'>
        <div className="relative h-screen w-screen">
          <div className="absolute inset-0 grid grid-cols-2 grid-rows-2">
            <div className="bg-red-500"></div>
            <div className="bg-blue-500"></div>
            <div className="bg-yellow-500"></div>
            <div className="bg-green-500"></div>
          </div>
          <div className="absolute inset-0 flex justify-center items-center bg-white rounded-full z-10 custom">
            <div className="text-center p-8 max-w-2xl mx-auto ">
                <h1 className="text-gray-600 my-4">Thank you for your review!</h1>
                <p className="text-4xl font-bold text-gray-800">Please visit us again soon.</p>
                <Footer/>
</div></div></div></div>

  )
}

export default VisitAgain